import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar.tsx';
import { Button } from '@/components/ui/button.tsx';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu.tsx';
import { getNameAbbreviation } from '@/lib/name-abbreviation.ts';
import { User } from '@/model/User.ts';
import { authService } from '@/service/AuthService';
import { useTranslation } from 'react-i18next';
import { LuGem, LuHistory, LuKeySquare, LuLogOut, LuSparkles, LuUser } from 'react-icons/lu';
import { useNavigate } from 'react-router-dom';

type UserDropdownMenuProps = {
  user: User;
};

const UserDropdownMenu = (props: UserDropdownMenuProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="secondary" size="icon" className="rounded-full m-1 h-10 w-10">
          <Avatar>
            <AvatarImage src="" />
            <AvatarFallback className="border-2 border-indigo-700">
              {getNameAbbreviation(props?.user.fullName)}
            </AvatarFallback>
          </Avatar>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>{props?.user.fullName}</DropdownMenuLabel>
        {props?.user.isAdmin && (
          <DropdownMenuItem onClick={() => navigate('/admin')}>
            <LuKeySquare className="mr-2 h-4 w-4 text-indigo-600" />
            {t('userMenu.admin')}
          </DropdownMenuItem>
        )}

        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => navigate('/profile')}>
          <LuUser className="mr-2 h-4 w-4 text-indigo-600" />
          {t('userMenu.profile')}
        </DropdownMenuItem>
        {import.meta.env.VITE_APP_ASK_FEATURE_ENABLED === 'true' && (
          <DropdownMenuItem onClick={() => navigate('/ask')}>
            <LuSparkles className="mr-2 h-4 w-4 text-indigo-600" />
            {t('userMenu.ask')}
          </DropdownMenuItem>
        )}
        <DropdownMenuItem onClick={() => navigate('/history')}>
          <LuHistory className="mr-2 h-4 w-4 text-indigo-600" />
          {t('userMenu.history')}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => navigate('/pricing')}>
          <LuGem className="mr-2 h-4 w-4 text-indigo-600" />
          {t('userMenu.pricing')}
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => authService.logout()}>
          <LuLogOut className="mr-2 h-4 w-4 text-indigo-600" />
          {t('userMenu.logout')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default UserDropdownMenu;
